/**
 * Defence-in-depth against stored XSS via `<a href>`.
 *
 * `url` values rendered here originate from the database (`spm_info_v1`/`spm_integration_info_v1`)
 * and, on the read path, are not schema-validated — only the SPM crawler's own writes go through
 * `parseGitUrl` origin checks. A hand-authored row (these tables are edited by hand) could smuggle
 * a `javascript:` URL straight into `href`, and React does not sanitize `href` for us.
 *
 * Returns `url` unchanged when it starts with an `http://`/`https://` scheme (case-insensitive),
 * otherwise `undefined` so the caller can fall back to rendering plain text instead of a link.
 */
export const safeHref = (url?: string | null): string | undefined =>
  url && /^https?:\/\//i.test(url) ? url : undefined;
